import { createContext as o } from "react";
const e = "GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider", t = o({
  instance: void 0,
  siteKey: "",
  language: "",
  isLoading: !0,
  executeV3: () => {
    throw new Error(e);
  },
  executeV2Invisible: () => {
    throw new Error(e);
  },
  reset: () => {
    throw new Error(e);
  },
  getResponse: () => {
    throw new Error(e);
  },
  render: () => {
    throw new Error(e);
  }
});
export {
  t as GoogleReCaptchaContext
};
//# sourceMappingURL=GoogleReCaptchaContext.mjs.map
